/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Cc_Label2Inputs */

const en_coinvestments_editemail_cc_label2 = /** @type {(inputs: Coinvestments_Editemail_Cc_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CC`)
};

/**
* | output |
* | --- |
* | "CC" |
*
* @param {Coinvestments_Editemail_Cc_Label2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_cc_label2 = /** @type {((inputs?: Coinvestments_Editemail_Cc_Label2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Cc_Label2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_cc_label2(inputs)
});
export { coinvestments_editemail_cc_label2 as "coInvestments_editEmail_cc_label" }